<template>
  <div
    :class="[
      'grid gap-x-8 md:grid-cols-3 lg:grid-cols-4 md:gap-x-16',
      columns === 1 ? 'grid-cols-1' : 'grid-cols-2',
    ]"
  >
    <div v-for="i in count" :key="i" class="flex flex-col">
      <RevSkeleton
        :class="
          columns === 1 ? '!rounded-none h-200' : '!rounded-none aspect-square'
        "
        height="100%"
        shape="rectangle"
        width="100%"
      />
      <div class="mt-8 px-[10px] pb-16">
        <div class="flex items-baseline justify-between gap-8">
          <RevSkeleton height="14px" shape="rectangle" width="60%" />
          <RevSkeleton height="14px" shape="rectangle" width="30%" />
        </div>
        <div class="mt-4">
          <RevSkeleton height="12px" shape="rectangle" width="80%" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevSkeleton } from '@ds/components/Skeleton'

withDefaults(defineProps<{ columns?: 1 | 2; count?: number }>(), {
  columns: 2,
  count: 8,
})
</script>
